/**
 * 图片列表可拖动排序
 */
import React, {Component} from 'react';
import moveIcon from "../../../view/components/storySortModal/image/icon_5@2x.png";
import {Form, Input, Modal, Table} from "antd";
import {DndProvider, DragSource, DropTarget} from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";
import PictureView from "./PictureView";

const FormItem = Form.Item;
const {TextArea} = Input;

let dragIndex = -1;

class BodyRow extends React.Component {
    render() {
        const {isOver, connectDragSource, connectDropTarget, moveRow, ...restProps} = this.props;
        const style = {...restProps.style, cursor: 'move'};

        let {className} = restProps;
        if (isOver) {
            if (restProps.index > dragIndex) {
                className += ' drop-over-downward';
            }
            if (restProps.index < dragIndex) {
                className += ' drop-over-upward';
            }
        }

        return connectDragSource(
            connectDropTarget(<tr id={restProps.index + "dragTr"} {...restProps} className={className} style={style}/>),
        );
    }
}

const rowSource = {
    beginDrag(props) {
        dragIndex = props.index;
        return {
            index: props.index,
        };
    },
};

const rowTarget = {
    drop(props, monitor) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Time to actually perform the action
        props.moveRow(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    },
};

const DragBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
    isOver: monitor.isOver(),
}))(
    DragSource('row', rowSource, connect => ({
        connectDragSource: connect.dragSource(),
    }))(BodyRow),
);

export default class DragAtlas extends Component {
    static propTypes = {};
    static defaultProps = {
        orderField: "orderField"
    };

    constructor(props) {
        super(props);
        this.state = {
            sortList: props.sortList,
            sortColumns: [],
            clickItem: {}
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getSortColumns();
    }

    componentWillReceiveProps(nextProps, nextContext) {
        nextProps.sortList.map(item => {
            return{
                ...item,
                hover: false
            }
        })
        this.setState({
            sortList: nextProps.sortList
        })
    }

    getSortColumns = () => {
        const sortColumns = [
            {
                title: "图片",
                width: "30%",
                key: "pic",
                align: "center",
                render: (text, record) => {
                    return <>
                        {this.renderImage(record)}
                    </>
                }
            },
            {
                title: "描述",
                width: "30%",
                key: "dec",
                align: "left",
                render: (text, record, index) => {
                    return <>
                        {this.renderDescribeInfo(record, index)}
                    </>
                }
            },
            {
                title: "操作",
                width: "40%",
                key: "operate",
                align: "left",
                render: (text, record, index) => {
                    return <>
                        {this.renderUpdate(record, index)}
                    </>
                }
            }
        ];
        this.setState({
            sortColumns
        });
    };

    components = {
        body: {
            row: DragBodyRow,
        },
    };

    /**
     * 拖拽排序
     * @param dragIndex 拖拽行下标
     * @param hoverIndex 换到行的下标
     * dragIndex > hoverIndex 从下往上拖，反之从上往下拖
     * 从上往下拖 1，2，3
     *      1->2 2->3 3->1
     * 从下往上 1，2，3
     *      3->1 1->2 2->3
     */
    moveRow = (dragIndex, hoverIndex) => {
        const {sortList} = this.state;
        const {orderField} = this.props; //排序字段
        if (dragIndex < hoverIndex) {
            for (let index = dragIndex; index < hoverIndex; index++) {
                let indexRow = sortList[index];
                let indexRowOrder = indexRow[orderField];

                let nextIndex = index + 1;
                if (nextIndex > hoverIndex) {
                    nextIndex = dragIndex;
                }
                let nextRow = sortList[nextIndex];
                // 交换排序字段
                indexRow[orderField] = nextRow[orderField];
                nextRow[orderField] = indexRowOrder;

                // 交换下标
                sortList[index] = nextRow;
                sortList[nextIndex] = indexRow;
            }
        } else {
            for (let index = dragIndex; index > hoverIndex; index--) {
                let indexRow = sortList[index];
                let indexRowOrder = indexRow[orderField];

                let prevIndex = index - 1;
                if (prevIndex < hoverIndex) {
                    prevIndex = hoverIndex;
                }
                let preRow = sortList[prevIndex];
                // 交换排序字段
                indexRow[orderField] = preRow[orderField];
                preRow[orderField] = indexRowOrder;

                // 交换下标
                sortList[index] = preRow;
                sortList[prevIndex] = indexRow;
            }
        }
        this.setState({sortList});
    };

    render() {
        let {sortColumns, sortList} = this.state;
        return (
            <DndProvider backend={HTML5Backend}>
                {/*<Scrollbars autoHeight autoHide autoHeightMax={600}>*/}
                    <Table
                        rowKey={"key"}
                        id={'storyTable'}
                        columns={sortColumns}
                        dataSource={sortList}
                        components={this.components}
                        onRow={(record, index) => ({
                            index,
                            moveRow: this.moveRow,
                        })}
                        pagination={false}
                    >
                    </Table>
                {/*</Scrollbars>*/}
                {this.renderEditPhoto()}
                <style>
                    {`#storyTable .ant-table-tbody .ant-table-row{border-bottom:1px solid #e8e8e8 } #storyTable .ant-table-content .ant-table-body table {border-collapse:collapse ! important}
                      #storyTable .ant-table-placeholder{z-index: 0;}
                    `}
                </style>
            </DndProvider>
        )
    }

    renderImage = (record) => {
        let width = 200;
        let height = 112.5;
        return (
            <div style={{display: 'flex', alignItems: "center", justifyContent: "center"}}>
                <div style={{position: 'relative', width: width, height: height}}>
                    <PictureView key={record.id} currentItem={record} width={width} height={height}/>
                </div>
            </div>
        )
    };

    renderDescribeInfo = (record, index) => {
        let file = record;
        const {disable} = this.props;
        return (
            <div>
                <TextArea rows={4}
                          disabled={disable}
                          value={file.describe}
                          maxLength={100}
                          placeholder={'请输入描述信息，不超过100字'}
                          onMouseEnter={(e) => {
                              document.getElementById(index + "dragTr").setAttribute("draggable", "false");
                          }}
                          onMouseLeave={() => {
                              document.getElementById(index + "dragTr").setAttribute("draggable", "true");
                          }}
                          onMouseMove={(e) => {
                              document.getElementById(index + "dragTr").setAttribute("draggable", "false");
                          }}
                          onChange={e => {
                              file.describe = e.target.value;
                              this.setState({})
                          }}
                />
            </div>
        )
    };

    renderUpdate = (record, index) => {
        const {disable, hideSetTitlePic} = this.props;
        return (
            <div style={{display: 'flex'}}>
                {disable ? null :
                    <>
                        <div style={{cursor: 'pointer'}} onClick={() => {
                            this.setState({editPhotoVisible: true, clickItem: record})
                        }}>修改
                        </div>
                        <div onClick={() => {

                            this.editCover(record.url, record.title + "-裁剪.png", (path) => {
                                record.url = path;
                                this.setState({});
                            })
                        }} style={{marginLeft: 16, cursor: 'pointer'}}>编辑
                        </div>
                        <div onClick={() => {
                            if (typeof this.props.onDeleteCall == 'function') {
                                this.props.onDeleteCall(record.uid, index)
                            }
                        }} style={{color: 'red', marginLeft: 16, cursor: 'pointer'}}>删除
                        </div>
                        {!hideSetTitlePic && <div onClick={() => {
                            if (typeof this.props.onEditTitlePicCall == 'function') {
                                this.props.onEditTitlePicCall(record.url)
                            }
                        }} style={{marginLeft: 16, cursor: 'pointer'}}>设为预览图
                        </div>}
                        <div style={{marginLeft: 16}}>
                            <img alt={"拖动排序"} src={moveIcon} style={{width: 20, marginTop: -2, marginRight: 5}}/>
                            <span style={{color: '#0050B3'}}>拖动排序</span>
                        </div>
                    </>
                }
            </div>

        )
    }

    editCover = (src, name, call) => {
        if (src) {
            window.edit.callback = function (obj) {
                call && call(obj.path)
            };
            window.edit.openEditPictureFrame(src, name);
        } else {
            console.log("待编辑图片地址丢失")
        }
    };


    renderEditPhoto = () => {
        let file = this.state.clickItem;
        let name = file && file.title && file.title.substring(0, file.title.lastIndexOf("."));
        let suffix = file && file.suffix ? file.suffix : file.ext;
        return (
            <Modal
                centered={true}
                title="组图信息编辑"
                visible={this.state.editPhotoVisible}
                onOk={() => {
                    if (typeof this.props.onEditDescriptionCall == 'function') {
                        this.props.onEditDescriptionCall(file, file.uid)
                    }
                    this.setState({editPhotoVisible: false})
                }}
                maskClosable={false}
                onCancel={() => {
                    this.setState({editPhotoVisible: false})
                }}
                width={500}
                destroyOnClose={true}
            >
                <Form labelCol={{span: 4}} wrapperCol={{span: 17}}
                      onSubmit={(e) => { // 启动了表单的回车确认功能
                      }}>
                    <FormItem
                        label={'图标标题'}
                        required={true}
                    >
                        <div>
                            <Input
                                style={{width: 275}}
                                onChange={(e) => {
                                    file.title = e.target.value + '.' + suffix;
                                    this.setState({})
                                }}
                                value={name}
                            />
                            <span> . {suffix}</span>
                        </div>

                    </FormItem>
                    <FormItem
                        label={'图片描述'}
                        required={false}
                    >
                        <TextArea
                            style={{resize: 'none', background: '#eef2fb'}}
                            value={file.describe}
                            onChange={(e) => {
                                file.describe = e.target.value;
                                this.setState({})
                            }}
                            placeholder="请输入"
                            autoSize={{minRows: 3, maxRows: 5}}
                        />
                    </FormItem>
                </Form>
            </Modal>
        )
    };

}